import React from "react";
import {
    Routes,
    Route,
    Navigate,
} from "react-router-dom";
import Callback from "../keycloak/callback";
import { CatalogPage } from "../pages/Model-Catalog/CatalogPage";
import { DashboardPage } from "../pages/DashboardPage";
import { Layout } from "../components/Layout";
import ModelRouteConfigPage from "../pages/Model-Router/ModelRouteConfigPage";
import ModalComparePage from "../pages/Modal-Compare/ModalComparePage";
import { DeploymentsPage } from "../pages/Deployment-Instance/DeploymentsPage";
import { DeploymentDetailPage } from "../pages/Deployment-Instance/DeploymentDetailPage";
import { ModelViewPage } from "../pages/Model-Catalog/ModelViewPage";
import { GuardrailsPage } from '../pages/GuardrailsPage';
import { GuardrailsListPage } from '../pages/GuardrailsListPage';
import { RagPage } from "../pages/Rag/RagPage";
import { RagAddPage } from "../pages/Rag/RagAddPage";
import { FineTuningPage } from "../pages/Fine-Tuning/FineTuningPage";
import { PromptLabList } from "../pages/PromptLab/PromptLabList";
import { PromptLabAdd } from "../pages/PromptLab/PromptLabAdd";
import { PromptLabEdit } from "../pages/PromptLab/PromptLabEdit";
import { UsageCategoriesPage } from "../pages/UsageCategoriesPage";
import { DatasetsPage } from "../pages/Evaluation/DatasetsPage";
import { DatasetAddPage } from "../pages/Evaluation/DatasetAddPage";
import { EvaluationPage } from "../pages/Evaluation/EvaluationPage";
import { EvaluationAddPage } from "../pages/Evaluation/EvaluationAddPage";
import { EvaluationDetailPage } from "../pages/Evaluation/EvaluationDetailPage";


interface AppRoutesProps {
    isAuthenticated: boolean;
    setIsAuthenticated: (auth: boolean) => void;
}

const AppRoutes: React.FC<AppRoutesProps> = ({
    isAuthenticated,
    setIsAuthenticated,
}) => {
    return (
        <Routes>
            {/* Keycloak callback route - always accessible for OAuth flow */}
            <Route
                path="/keycloak/callback"
                element={<Callback />}
            />

            {isAuthenticated && (
                <>
                    <Route path="/dashboard" element={<Layout><DashboardPage /></Layout>} />
                    <Route path="/catalog" element={<Layout><CatalogPage /></Layout>} />
                    <Route path="/model/:modelId" element={<Layout><ModelViewPage /></Layout>} />
                    <Route path="/compare" element={<Layout><ModalComparePage /></Layout>} />
                    <Route path="/deployments" element={<Layout><DeploymentsPage /></Layout>} />
                    <Route path="/deployment/:deploymentId" element={<Layout><DeploymentDetailPage /></Layout>} />
                    <Route path="/model-route-config" element={<Layout><ModelRouteConfigPage /></Layout>} />
                    <Route path="/guardrails" element={<Layout><GuardrailsListPage /></Layout>}/>
                    <Route path="/guardrails/new" element={<Layout> <GuardrailsPage /> </Layout>}/>
                    <Route path="/guardrails/:id" element={<Layout><GuardrailsPage /></Layout>}/>
                    <Route path="/prompt-lab" element={<Layout><PromptLabList /></Layout>}/>
                    <Route path="/prompt-lab/add" element={<Layout><PromptLabAdd /></Layout>}/>
                    <Route path="/prompt-lab/edit/:id" element={<Layout><PromptLabEdit /></Layout>}/>
                    <Route path="/prompt-lab/usage-categories" element={<Layout><UsageCategoriesPage /></Layout>}/>
                    <Route path="/rag" element={<Layout><RagPage /></Layout>}/>
                    <Route path="/rag/add" element={<Layout><RagAddPage /></Layout>}/>
                    <Route path="/fine-tuning" element={<Layout><FineTuningPage /></Layout>}/>
                    <Route path="/evaluation/datasets" element={<Layout><DatasetsPage /></Layout>}/>
                    <Route path="/evaluation/datasets/add" element={<Layout><DatasetAddPage /></Layout>}/>
                    <Route path="/evaluation" element={<Layout><EvaluationPage /></Layout>}/>
                    <Route path="/evaluation/add" element={<Layout><EvaluationAddPage /></Layout>}/>
                    <Route path="/evaluation/:id" element={<Layout><EvaluationDetailPage /></Layout>}/>
                </>
            )}

            {!isAuthenticated && (
                <Route
                    path="*"
                    element={
                        <div className="min-h-screen flex items-center justify-center">
                            <div className="text-center">
                                <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-blue-600 mx-auto"></div>
                                <p className="mt-6 text-lg text-gray-700 font-medium">
                                    Redirecting to login...
                                </p>
                            </div>
                        </div>
                    }
                />
            )}

            {/* Default route - redirect to dashboard */}
            <Route path="/" element={<Navigate to="/dashboard" replace />} />

            {/* Catch all - redirect to home */}
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
    );
};

export default AppRoutes;